<template>
    <div v-if="form_data">
        <kt-nav space="md" size="lg" id="kt-nav">
            <form @submit.prevent="disableTerminal" id="disableTerminal_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="disableTerminal">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingTwo">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#disableTerminalForm"
                                     aria-controls="disableTerminalForm">
                                    <i class="fa fa-ban"></i>
                                    {{ $t('panel.shaparak-requests.terminal-deactivation') }}
                                </div>
                            </div>
                            <div
                                    id="disableTerminalForm"
                                    class="collapse"
                                    aria-labelledby="disableTerminalForm"
                                    data-parent="#disableTerminal"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="disableTerminal_btn">
                                            {{ $t('panel.shaparak-requests.send_block_request') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
            <form @submit.prevent="enableTerminal" id="enableTerminal_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="enableTerminal">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingThree">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#enableForm"
                                     aria-controls="enableForm">
                                    <i class="fa fa-redo"></i>
                                    {{ $t('panel.shaparak-requests.terminal-re-activation') }}
                                </div>
                            </div>
                            <div
                                    id="enableForm"
                                    class="collapse"
                                    aria-labelledby="enableForm"
                                    data-parent="#enableTerminal"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="enableTerminal_btn">
                                            {{ $t('panel.shaparak-requests.send_enable_request') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
            <form @submit.prevent="changeAddress" id="changeAddress_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="changeAddress">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingFour">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#addressForm"
                                     aria-controls="addressForm">
                                    <i class="fa fa-location-arrow"></i>
                                    {{ $t('panel.shaparak-requests.change-address') }}
                                </div>
                            </div>
                            <div
                                    id="addressForm"
                                    class="collapse"
                                    aria-labelledby="addressForm"
                                    data-parent="#changeAddress"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="address">
                                                        {{ $t('panel.shaparak-requests.addresses') }}
                                                    </kt-form-label>
                                                    <select
                                                            size="4"
                                                            id="address"
                                                            class="form-control kt-selectpicker"
                                                            v-model="form_data.address"
                                                            name="address">
                                                        <option
                                                                v-for="address in addresses"
                                                                v-bind:key="address.id"
                                                                :selected="form_data.address === address.id"
                                                                :value="address.id"
                                                        >
                                                            {{ address.address }}
                                                        </option>
                                                    </select>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="changeAddress_btn">
                                            {{ $t('panel.shaparak-requests.send_to_shaparak') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
            <form @submit.prevent="changeShopInfo" id="changeShop_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="changeShopInfo">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingFour">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#shopInfo"
                                     aria-controls="shopInfo">
                                    <i class="fa fa-pencil-alt"></i>
                                    {{ $t('panel.shaparak-requests.change_shop_info') }}
                                </div>
                            </div>
                            <div
                                    id="shopInfo"
                                    class="collapse"
                                    aria-labelledby="shopInfo"
                                    data-parent="#changeShopInfo"
                            >
                                <div class="mt-3 card-body border in-border-header bg-light">
                                  <div class="section-header ">
                                    {{ $t('panel.shaparak-requests.change_shop_info') }}
                                  </div>
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="farsi_name">
                                                      {{ $t('label.farsi_name') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                        id="farsi_name"
                                                        name="farsi_name"
                                                        v-model="form_data.farsi_name"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                              <kt-form-group>
                                                <kt-form-label for="english_name">
                                                  {{ $t('label.english_name') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    id="english_name"
                                                    name="english_name"
                                                    v-model="form_data.english_name"
                                                    dir="ltr"
                                                >
                                                </kt-form-control>
                                              </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="site_address">
                                                        {{ $t('label.site_address') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                        dir="ltr"
                                                        id="site_address"
                                                        name="site_address"
                                                        placeholder="https://mysite.ir/"
                                                        v-model="form_data.site_address"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-col>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                              <kt-form-group>
                                                <kt-form-label for="telephone">
                                                  {{ $t('label.telephone') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    dir="ltr"
                                                    id="telephone"
                                                    name="telephone"
                                                    v-model="form_data.telephone"
                                                >
                                                </kt-form-control>
                                              </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="changeShopInfo_btn">
                                            {{ $t('panel.shaparak-requests.send_to_shaparak') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
            <form @submit.prevent="changeCategoryCode" id="changeCategoryCode_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="changeCategoryCode">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingFour">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#categoryCode"
                                     aria-controls="categoryCode">
                                    <i class="fa fa-clipboard-list"></i>
                                    {{ $t('panel.shaparak-requests.change_category_code') }}
                                </div>
                            </div>
                            <div
                                    id="categoryCode"
                                    class="collapse"
                                    aria-labelledby="categoryCode"
                                    data-parent="#changeCategoryCode"
                            >
                                <div class="mt-3 card-body border in-border-header bg-light">
                                  <div class="section-header ">
                                    {{ $t('panel.shaparak-requests.change_category_code') }}
                                  </div>
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="12" lg="12">
                                              <kt-form-group>
                                                <kt-form-label for="subcategory_code">
                                                  {{ $t('label.subcategory_code') }}
                                                </kt-form-label>
                                                <select
                                                    id="subcategory_code"
                                                    name="subcategory_code"
                                                    v-model="form_data.subcategory_code"
                                                    class="form-control kt-selectpicker"
                                                >
                                                  <option
                                                      v-bind:key="subcategory.key"
                                                      v-for="subcategory in subcategories"
                                                      :selected="form_data.subcategory_code == subcategory.key"
                                                      :value="subcategory.key"
                                                  >
                                                    {{ subcategory.value }}
                                                  </option>
                                                </select>
                                              </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="changeCategoryCode_btn">
                                            {{ $t('panel.shaparak-requests.send_to_shaparak') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
        </kt-nav>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import $ from "jquery";
    import {KTApp} from '@/plugins/core/app'
    import {gatewayService, stakeholdersService} from '@/common/api.service'
    import {gatewayStatus} from '@/constants/gatewayStatus'
    import {i18n} from '@/plugins/i18n'
    import { subcategories } from '@/constants/subcategories'



    export default {
        props: {
            form_data: {
                required: true,
            },
            addresses: {
                required: true,
            },
            sheba_numbers: {
                required: true
            }
        },
        data() {
            return {
                gatewayStatus: {
                    active: gatewayStatus.ACTIVE,
                    blocked: gatewayStatus.BLOCKED
                },
                relatedMerchants: [],
              subcategories: subcategories,
              is_starshop: this.$route.params.gateway_source === 'starshop-gateways',
            }
        },
        computed: {
            ...mapGetters('gateway', {
                gateway: 'form_data',
                status: 'status'
            }),
            ...mapGetters('pspRequest', [
                'current_psp_tab',
            ]),
        },
        mounted() {
            stakeholdersService.get_all_business_stakeholders(this.is_starshop).then(response => {
                this.relatedMerchants = response.data.data;
            }).finally(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });
            });
        },
        methods: {
            disableTerminal(e) {
                let form = $('#disableTerminal_form')
                let btn = $('#disableTerminal_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'shop_id': this.$route.params.hashid,
                    'psp': this.current_psp_tab
                }

                gatewayService.disableTerminal(params, this.is_starshop)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
            enableTerminal(e) {
                let form = $('#enableTerminal_form')
                let btn = $('#enableTerminal_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'shop_id': this.$route.params.hashid,
                    'psp': this.current_psp_tab
                }
                gatewayService.enableTerminal(params, this.is_starshop)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
            changeAddress(e) {
                let form = $('#changeAddress_form')
                let btn = $('#changeAddress_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'address_id': this.form_data.address,
                    'shop_id': this.$route.params.hashid,
                    'psp': this.current_psp_tab
                }
                gatewayService.changeAddress(params, this.is_starshop)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
            changeShopInfo(e) {
                let form = $('#changeShop_form')
                let btn = $('#changeShopInfo_btn')
                let nav = $('#kt-nav')
                form.validate({
                  rules: {
                      farsi_name: {
                        required: true
                      },
                      english_name: {
                        required: true
                      },
                      site_address: {
                        required: true
                      },
                      telephone: {
                        required: true
                      },
                    }
                  })
              if(!form.valid()) {
                return
              }

                KTApp.progress(btn)

                let params = {
                    'farsi_name': this.form_data.farsi_name,
                    'english_name': this.form_data.english_name,
                    'site_address': this.form_data.site_address,
                    'telephone': this.form_data.telephone,
                    'hashid': this.$route.params.hashid,
                    'psp': this.current_psp_tab
                }

                gatewayService.changeinfo(params, this.is_starshop)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
            changeCategoryCode(e) {
                let form = $('#changeCategoryCode_form')
                let btn = $('#changeCategoryCode_btn')
                let nav = $('#kt-nav')
                form.validate({
                  rules: {
                      subcategory_code: {
                        required: true
                      }
                    }
                  })
              if(!form.valid()) {
                return
              }

                KTApp.progress(btn)

                let params = {
                    'subcategory_code': this.form_data.subcategory_code,
                    'shop_id': this.$route.params.hashid,
                    'psp' : this.current_psp_tab
                }

                gatewayService.changeCategoryCode(params, this.is_starshop)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
        }
    }
</script>

<style>
    .accordion, .card {
        border: none !important;
    }
</style>